import { IconProps } from "@/types/types";

export default function PlusBox({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7 3C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H17.0001C19.2092 21 21.0001 19.2091 21.0001 17V7C21.0001 4.79086 19.2092 3 17.0001 3H7ZM10.7499 15.25C10.7499 15.9404 11.3095 16.5 11.9999 16.5C12.6902 16.5 13.2499 15.9404 13.2499 15.25V13.25H15.2499C15.9402 13.25 16.4999 12.6904 16.4999 12C16.4999 11.3096 15.9402 10.75 15.2499 10.75H13.2499V8.75C13.2499 8.05965 12.6902 7.5 11.9999 7.5C11.3095 7.5 10.7499 8.05965 10.7499 8.75V10.75H8.74991C8.05955 10.75 7.49991 11.3096 7.49991 12C7.49991 12.6904 8.05955 13.25 8.74991 13.25H10.7499V15.25Z" fill="currentColor" />
        </svg>
    )
}

